<template>
  <v-list-item
    three-line
    class="pa-0"
  >
    <v-list-item-avatar>
      <v-avatar
        class="grey white--text"
        size="30"
      >
        {{ userInitials }}
      </v-avatar>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>{{ message.author }}</v-list-item-title>
      <v-list-item-subtitle>{{ createdAt }}</v-list-item-subtitle>
      <div class="text-message-body">{{ message.body }}</div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { initials } from "@/utils/string"
import { stringToDate, toTimeOrDatetime } from "@/utils/datetime"

export default {
  name: "CommentItem",
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    createdAt() {
      return toTimeOrDatetime(stringToDate(this.message.dateUpdated))
    },
    userInitials() {
      return initials(this.message.author)
    }
  }
}
</script>

<style lang="scss">
.text-message-body {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  word-wrap: anywhere;
}
</style>
